<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container">
  <div class="row mt-5">
    <div class="col-md-12 text-center" style="font-size:1.0em; font-weight:bold">
      <i>Frasco, et al v. Flo Health, Inc., et al. No. 3:21-cv-00757-JD (N.D. Cal.)</i>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12 text-center" style="font-size:1.6em; font-weight:bold">
      CLAIM FORM
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12">
      Before completing this form, it is important that you review the <b>Notice of Proposed Class Action Settlements, Final Approval Hearing and Class Members’ Rights</b> (“Notice”), and the Settlement
      Agreements between Plaintiffs and Flurry LLC, Google LLC, and Flo Health, Inc., which are available <a [routerLink]="['/contact']">HERE.</a><br /><br />

      The deadline to submit this online Claim Form is <b>11:59 p.m. Pacific Time on October 15, 2026.</b> If you choose to submit a paper Claim Form instead, it must be postmarked by no
      later than October 15, 2026.
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12" style="font-weight:bold">
      I. CLAIMANT INFORMATION
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      The Settlement Administrator will use this information for all communications relevant to this Claim Form and may use it in connection with anything related to this case.
    </div>
  </div>
  <br />
  <div class="container">
    <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="firstName">First Name:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="firstName" formControlName="firstName" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.firstName.errors && (f.firstName.dirty || f.firstName.touched || f.firstName.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.firstName" class="invalid-feedback">
              <div *ngIf="f.firstName.hasError(validation.type) && (f.firstName.dirty || f.firstName.touched || f.firstName.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="lastName">Last Name:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="lastName" formControlName="lastName" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.lastName.errors && (f.lastName.dirty || f.lastName.touched || f.lastName.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.lastName" class="invalid-feedback">
              <div *ngIf="f.lastName.hasError(validation.type) && (f.lastName.dirty || f.lastName.touched || f.lastName.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2" style="font-weight: bold; font-size: 1.5em">Current Address</div><br />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street1">Street Address (no P.O. Boxes):<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors && (f.street1.dirty || f.street1.touched || f.street1.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.street1" class="invalid-feedback">
              <div *ngIf="f.street1.hasError(validation.type) && (f.street1.dirty || f.street1.touched || f.street1.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="city">City:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="city" formControlName="city" placeholder="" autocomplete="off"
                   trim="blur" [ngClass]="{ 'is-invalid': f.city.errors && (f.city.dirty || f.city.touched || f.city.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.city" class="invalid-feedback">
              <div *ngIf="f.city.hasError(validation.type) && (f.city.dirty || f.city.touched || f.city.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label class="titleBold" for="state">State:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors && (f.state.dirty || f.state.touched || f.state.pristine )}">
            <option value="">Please select a State</option>
            <option *ngFor="let allstate of allStates">
              {{allstate.Name}}
            </option>
          </select>
          <div *ngFor="let validation of validation_FormErrorMessages.state" class="invalid-feedback">
            <div *ngIf="f.state.hasError(validation.type) && (f.state.dirty || f.state.touched || f.state.pristine)">
              {{ validation.message }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="zip">Zip Code:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="zip" formControlName="zip"
                   placeholder="Zip Code: (XXXXX or XXXXX-XXXX)" autocomplete="off" trim="blur"
                   [ngClass]="{ 'is-invalid': f.zip.errors && (f.zip.dirty || f.zip.touched || f.zip.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.zip" class="invalid-feedback">
              <div *ngIf="f.zip.hasError(validation.type) && (f.zip.dirty || f.zip.touched || f.zip.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2" style="font-weight: bold; font-size: 1.5em">Address Between November 1, 2016 and February 28, 2019</div><br />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street2">Street Address (no P.O. Boxes):<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="street2" formControlName="street2" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.street2.errors && (f.street2.dirty || f.street2.touched || f.street2.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.street2" class="invalid-feedback">
              <div *ngIf="f.street2.hasError(validation.type) && (f.street2.dirty || f.street2.touched || f.street2.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="city2">City:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="city2" formControlName="city2" placeholder="" autocomplete="off"
                   trim="blur" [ngClass]="{ 'is-invalid': f.city2.errors && (f.city2.dirty || f.city2.touched || f.city2.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.city2" class="invalid-feedback">
              <div *ngIf="f.city2.hasError(validation.type) && (f.city2.dirty || f.city2.touched || f.city2.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label class="titleBold" for="state2">State:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="state2" [ngClass]="{ 'is-invalid': f.state2.errors && (f.state2.dirty || f.state2.touched || f.state2.pristine )}">
            <option value="">Please select a State</option>
            <option *ngFor="let allstate of allStates">
              {{allstate.Name}}
            </option>
          </select>
          <div *ngFor="let validation of validation_FormErrorMessages.state2" class="invalid-feedback">
            <div *ngIf="f.state2.hasError(validation.type) && (f.state2.dirty || f.state2.touched || f.state2.pristine)">
              {{ validation.message }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="zip2">Zip Code:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="zip2" formControlName="zip2"
                   placeholder="Zip Code: (XXXXX or XXXXX-XXXX)" autocomplete="off" trim="blur"
                   [ngClass]="{ 'is-invalid': f.zip2.errors && (f.zip2.dirty || f.zip2.touched || f.zip2.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.zip2" class="invalid-feedback">
              <div *ngIf="f.zip2.hasError(validation.type) && (f.zip2.dirty || f.zip2.touched || f.zip2.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="emailAddress">E-Mail Address:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors && (f.emailAddress.dirty || f.emailAddress.touched || f.emailAddress.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.emailAddress" class="invalid-feedback">
              <div *ngIf="f.emailAddress.hasError(validation.type) && (f.emailAddress.dirty || f.emailAddress.touched || f.emailAddress.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
          <!--By providing your email address, you authorize the Claims Administrator to use it to send you information relevant to this claim.-->
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="phone1">Phone Number:<span style="color:red" class="required"> *</span></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="phone1" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                   [ngClass]="{ 'is-invalid': f.phone1.errors && (f.phone1.dirty || f.phone1.touched || f.phone1.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.phone1" class="invalid-feedback">
              <div *ngIf="f.phone1.hasError(validation.type) && (f.phone1.dirty || f.phone1.touched || f.phone1.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          II. OPTIONAL UNIQUE ID AND PIN
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-2">
          If you received a Unique ID and PIN, please enter it below to assist with the processing of your claim.  This is <b>not</b> required to file a claim.
        </div>
      </div>
      <div class="row mt-2">

        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="uniqueId">Unique ID:</label>
            <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.uniqueId.errors && (f.uniqueId.dirty || f.uniqueId.touched || f.uniqueId.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.uniqueId" class="invalid-feedback">
              <div *ngIf="f.uniqueId.hasError(validation.type) && (f.uniqueId.dirty || f.uniqueId.touched || f.uniqueId.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="pin">PIN:</label>
            <input type="text" class="form-control" id="pin" formControlName="pin" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.pin.errors && (f.pin.dirty || f.pin.touched || f.pin.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.pin" class="invalid-feedback">
              <div *ngIf="f.pin.hasError(validation.type) && (f.pin.dirty || f.pin.touched || f.pin.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          III. PROOF OF CALIFORNIA RESIDENCY
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              If you lived in California during the Class Period (November 1, 2016, through and including February 28, 2019), please complete the information below. Because of
              California’s data protection laws, Authorized Claimants who prove they lived in California during the Class Period and used the Flo Period and Ovulation
              Tracker App (“Flo App”) while in California during the Class Period are eligible to receive a greater pro rata (or proportional) share of the Settlements
              than Authorized Claimants who lived in other states.<br /><br />

              At any time between November 1, 2016 and February 28, 2019, did you live in the state of California and enter menstruation and/or pregnancy information into the
              Flo App during that time?<br /><br />

              <div class="row">
                <div class="col-md-4">
                  <label class="titleBold" for="californiaResidentDuringPeriod">California Resident During Time Period:<span style="color:red" class="required"> *</span></label>
                  <select class="form-control" formControlName="californiaResidentDuringPeriod" (change)="getCaliforniaResidentValue($event)"
                          [ngClass]="{ 'is-invalid': f.californiaResidentDuringPeriod.errors && (f.californiaResidentDuringPeriod.dirty || f.californiaResidentDuringPeriod.touched
                          || f.californiaResidentDuringPeriod.pristine )}">
                    <option value="">Please Select Option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <div *ngFor="let validation of validation_FormErrorMessages.californiaResidentDuringPeriod" class="invalid-feedback">
                    <div *ngIf="f.californiaResidentDuringPeriod.hasError(validation.type) && (f.californiaResidentDuringPeriod.dirty || f.californiaResidentDuringPeriod.touched || f.californiaResidentDuringPeriod.pristine)">
                      {{ validation.message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivCaliforniaResident">
            <div class="row mt-4">
              <div class="col-md-12">
                <!--If you lived in California during the Class Period (November 1, 2016, through and including February 28, 2019), please complete the information below. Because of California’s data
            protection laws, Authorized Claimants who prove they lived in California during the Class Period and used the Flo Period and Ovulation Tracker App (“Flo App”) while in California
            during the Class Period are eligible to receive a greater pro rata (or proportional) share of the Settlements than Authorized Claimants who lived in other states.<br /><br />-->
                By selecting YES above, I acknowledge and consent to address verification solely for the purpose of verifying the state where I lived. This verification may be conducted through
                secure third-party validation services, and any addresses obtained or used for verification purposes will not be stored, shared, or used for any other purpose beyond the compliance
                and verification requirements in this case.<br /><br />


                If the Settlement Administrator is unable to verify your California residency, it may contact you for additional information. If you are not eligible to receive a payment as part
                of the California Subclass, you will still receive a standard share if you are an Authorized Claimant.<br /><br />

                If you were a California resident, you may be eligible for an additional payment related to a verdict against Meta arising from this litigation. If you are eligible to receive money
                from that verdict, you will be contacted at a later time.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          IV. PAYMENT METHOD AND NOTIFICATIONS
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <b>All information about payments will be sent to you digitally.</b> When you receive the email and/or mobile phone text notifying you of your payment, you will be provided with a
          number of digital payment options, such as PayPal, Venmo, Apple Pay, Amazon, or direct deposit, to immediately receive your payment. The email and/or text will also give
          you the option to request a paper check.<br /><br />

          By submitting this Claim, you agree to receive automated emails and/or text messages from the Settlement Administrator at the email and/or phone number you have provided regarding
          anything related to this case. Submission of this Claim Form does not guarantee payment. Your Claim must be approved by the Settlement Administrator. If you are unable to submit the
          required information as described below or have any questions, you should email the Settlement Administrator for further instructions.
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12" style="font-weight:bold">
          V. ACKNOWLEDGMENT AND CERTIFICATION
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          Submitting false information will render this Claim invalid.
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group form-check">
                <input type="checkbox" formControlName="acknowledgement" class="form-check-input" trim="blur" [ngClass]="{ 'is-invalid': f.acknowledgement.errors && (f.acknowledgement.dirty || f.acknowledgement.touched || f.acknowledgement.pristine )}" />
                <label for="californiaResidentDuringPeriod">
                  <b>
                    At any time between November 1, 2016 and February 28, 2019, I lived in the United States and entered menstruation and/or pregnancy information into the Flo App during that time.
                  </b>
                </label>
                <div *ngFor="let validation of validation_FormErrorMessages.acknowledgement" class="invalid-feedback">
                  <div *ngIf="f.acknowledgement.hasError(validation.type) && (f.acknowledgement.dirty || f.acknowledgement.touched || f.acknowledgement.pristine)">
                    {{ validation.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b>
            By signing below, I acknowledge that I understand and agree to be bound by the terms of each Settlement, the Notice, and this Claim Form, including the Releases provided for in the Settlements.
          </b><br /><br />

          <div style="font-size:1.2em; font-weight:bold">
            I DECLARE (OR CERTIFY, VERIFY, OR STATE) UNDER PENALTY OF PERJURY UNDER THE LAWS OF THE UNITED STATES OF AMERICA THAT ALL THE INFORMATION PROVIDED BY ME ON THIS CLAIM FORM IS TRUE AND CORRECT.
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="signature">Electronic Signature: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.signature.errors && (f.signature.dirty || f.signature.touched || f.signature.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.signature" class="invalid-feedback">
              <div *ngIf="f.signature.hasError(validation.type) && (f.signature.dirty || f.signature.touched || f.signature.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': f.googleRecaptchaToken.errors && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched || f.googleRecaptchaToken.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.googleRecaptchaToken" class="invalid-feedback">
              <div *ngIf="f.googleRecaptchaToken.hasError(validation.type) && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched || f.googleRecaptchaToken.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>
      <div *ngIf="errorMessage" class="alert alert-danger text-center">
        {{ errorMessage }}<br />
        <a href="../../../assets/docs/Claim Form.pdf"
           target="_blank" style="color:#006cDb">
          Claim Form
        </a>

      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="text-center" style="text-decoration:underline; font-weight:bold">
            REMINDER:
          </h5>
        </div>

        <div class="col-md-12 text-center">
          <b>YOUR CLAIM FORM MUST BE SUBMITTED ONLINE BY 11:59 P.M. PT ON OCTOBER 15, 2026 OR BE MAILED NO LATER THAN OCTOBER 15, 2026.</b><br /><br />
          If your information changes after you submit this form, please notify the Settlement Administrator in writing. Otherwise, you may not receive your payment.

          <div class="text-center">
            <i><b>Period Tracker Data Privacy Litigation</b></i><br />
            c/o A.B. Data, Ltd.<br />
            P.O. Box 173126<br />
            Milwaukee, WI 53217<br /><br />
            <a href="mailto:info@PeriodTrackerDataPrivacyLitigation.com" style="color:#006cDb">info@PeriodTrackerDataPrivacyLitigation.com</a><br />
          </div>
        </div>

      </div>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
